(() => {
  if (customElements.get('adornyu-hero-carousel')) return;
  customElements.define('adornyu-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2 || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.toggle = this.querySelector('.adny-carousel__toggle');
      this.status = this.querySelector('.adny-carousel__status');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.index = 0;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.querySelector('.adny-carousel__controls').hidden = false;
      const on = (node, event, fn) => node.addEventListener(event, fn, { signal });
      this.dots.forEach((dot, index) => on(dot, 'click', () => this.select(index, true)));
      on(this.toggle, 'click', () => { this.paused = !this.paused; this.schedule(); });
      on(this, 'pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.schedule(); } });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.reduced, 'change', () => { if (this.reduced.matches) this.paused = true; this.schedule(); });
      const stage = this.querySelector('.adny-carousel__slides');
      on(stage, 'pointerdown', e => {
        if (e.pointerType !== 'mouse' && e.isPrimary) {
          this.start = { x: e.clientX, y: e.clientY };
          clearTimeout(this.timer);
        }
      });
      on(stage, 'pointerup', e => {
        if (!this.start) return;
        const dx = e.clientX - this.start.x, dy = e.clientY - this.start.y;
        this.start = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.suppressClick = true;
          this.select(this.index + (dx < 0 ? 1 : -1), true);
          clearTimeout(this.clickTimer);
          this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 400);
        } else this.schedule();
      });
      on(stage, 'pointercancel', () => { this.start = null; this.schedule(); });
      stage.addEventListener('click', e => {
        if (this.suppressClick) { e.preventDefault(); e.stopPropagation(); this.suppressClick = false; }
      }, { capture: true, signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.25 });
      this.observer.observe(this);
      this.select(0);
      this.classList.add('is-ready');
    }
    select(index, manual = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
        slide.inert = i !== this.index;
        slide.setAttribute('aria-hidden', String(i !== this.index));
        this.dots[i].setAttribute('aria-current', String(i === this.index));
      });
      this.querySelector('.adny-carousel__count').textContent = `0${this.index + 1} / 0${this.slides.length}`;
      if (manual) {
        this.paused = true;
        this.status.textContent = this.index === 0 ? 'Wardrobe refresh event, banner 1 of 2' : 'Adornyu brand edit, banner 2 of 2';
      }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      this.toggle.textContent = this.paused ? 'Play' : 'Pause';
      this.toggle.setAttribute('aria-label', this.paused ? 'Start banner rotation' : 'Pause banner rotation');
      if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) {
        this.timer = setTimeout(() => this.select(this.index + 1), 6500);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.clickTimer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
